import { render } from "./ServicesPoste.vue?vue&type=template&id=7198bbb7&ts=true"
import script from "./ServicesPoste.vue?vue&type=script&lang=ts"
export * from "./ServicesPoste.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__